import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
import { startSpinner,finishSpinner } from "../ui/spinner";

export const resolucionesTraerStart = () => ({ type: types.resolucionesTraerStart });
export const resolucionesLimpiar = () => ({ type: types.resolucionesLimpiar });
export const resolucionesTraerError = (error) => ({ type: types.resolucionesTraerError, payload: error});
export const resolucionesSeleccionar = (payload) => ({ type: types.resolucionesSeleccionar, payload: payload});
export const resolucionesModificar = (payload) => ({ type: types.resolucionesModificar, payload: payload});
export const resolucionesEliminar = (payload) => ({ type: types.resolucionesEliminar, payload: payload});
export const resolucionesTraerSuccess = (payload) => {
    return {
        type: types.resolucionesTraerSuccess,
        payload: payload
    }
}

export const fetchResoluciones = () => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(resolucionesTraerStart());
        const response = await fetchConToken(`Resoluciones`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch(resolucionesTraerSuccess(lista));
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};

export const fetchResolucionesPorNorma = (norma) => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(resolucionesTraerStart());
        const response = await fetchConToken(`Resoluciones/traerPorNorma/${norma}`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch(resolucionesTraerSuccess(lista));
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};

export const agregarEditarResolucion = (norma, fechaDesde, fechaHasta, porcResarcitorio, porcPunitorio, idResolucion, callback) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      const response = await fetchConToken(`Resoluciones`, {norma, fechaDesde, fechaHasta, porcResarcitorio, porcPunitorio, idResolucion}, 'POST');
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        const items = await response.json();
        if (response.status !== 200) throw items.errores;
        // idResolucion === 0 ? dispatch(resolucionesTraerSuccess([...items, item])) : dispatch(resolucionesModificar(item));
        dispatch(resolucionesTraerSuccess(items));
        dispatch( startAlerta(`La resolución se ${idResolucion === 0 ? 'genero' : 'modifico'} correctamente`, "success", `Exito!`) );
        callback&& callback();
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const eliminarResolucion = (idResolucion) => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        const response = await fetchConToken(`Resoluciones`, {idResolucion}, 'DELETE');
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const item = await response.json();
          if (response.status !== 200) throw item.errores;
          dispatch( resolucionesEliminar(idResolucion) );
          dispatch( startAlerta("La resolución se elimino correctamente", "success", `Exito!`) );
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};